import { State } from './type'

const state: State = {
    setMenuState: false,
    detail: null,
}

const mutations = {
    toggleVersionSetMenuState(
        state: { setMenuState: boolean },
        value: boolean
    ) {
        state.setMenuState = value
    },
    setVersionDetail(state: { detail: null | Object }, value: Object | null) {
        state.detail = value
    },
}

export default {
    state,
    mutations,
}
